import { useReactiveVar, useSuspenseQuery } from '@apollo/client';

import { calculateSteps } from '@storefront/app/pdp-config/printer/product-configuration/product-configuration.utils';
import {
  GetSkuProductsDocument,
  GetSkuProductsQuery,
} from '@storefront/data-commerce';
import { getOptionsWithSteps } from '@storefront/utils/prodRequests';

import {
  BundleProductWithLowestPrice,
  getBundleProduct,
} from '../app/pdp-config/printer/product-configuration/product-configuration.utils';
import { configurationState } from '../app/pdp-config/printer/state-management/pdp-config-state';

export default function useGetProductsInformations(skuList: string[]) {
  const configuration = useReactiveVar(configurationState);
  const activeSKU = configuration.activeSku as string;
  const {
    data: {
      products: { items: multipleProductPlain },
    },
  } = useSuspenseQuery<GetSkuProductsQuery>(GetSkuProductsDocument, {
    variables: { skuList },
  });
  const multipleProduct =
    multipleProductPlain as BundleProductWithLowestPrice[];
  const bundleProduct = getBundleProduct(multipleProduct, activeSKU);
  const bundleOptions = getOptionsWithSteps({
    product: bundleProduct,
    filterOptional: true,
  });
  const { coreOfferTotalSteps, regularAndBundleTotalSteps } = calculateSteps(
    bundleOptions.steps
  );
  const totalSteps = coreOfferTotalSteps + regularAndBundleTotalSteps;

  return {
    multipleProduct,
    configuration,
    activeSKU,
    bundleProduct,
    bundleOptions,
    totalSteps,
  };
}
